export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选漫画分类
          </h2>
          <p className="text-sm text-foreground-500">发现你喜欢的漫画类型，开启精彩阅读之旅</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Epic%20action%20manga%20scene%20with%20dynamic%20battle%20poses%20and%20explosive%20effects%2C%20warm%20orange%20and%20red%20color%20scheme%2C%20Japanese%20shonen%20style%2C%20dramatic%20composition%20on%20cream%20background%2C%20editorial%20quality&width=600&height=800&seq=cards-manga-01&orientation=portrait"
                alt="51漫画网 - 热血冒险"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-2">最受欢迎</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">热血冒险</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">燃爆荷尔蒙的战斗与冒险，每页都是视觉盛宴</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Romantic%20manga%20illustration%20with%20soft%20pink%20and%20peach%20tones%2C%20cherry%20blossom%20petals%2C%20gentle%20expressions%2C%20shojo%20style%20art%2C%20dreamy%20atmosphere%20on%20cream%20paper%20texture%2C%20editorial%20quality&width=600&height=800&seq=cards-manga-02&orientation=portrait"
                alt="51漫画网 - 恋爱甜宠"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-2">人气飙升</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">恋爱甜宠</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">甜到心坎的浪漫故事，治愈你的每一个日常</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Fantasy%20manga%20art%20with%20magical%20elements%20and%20ethereal%20lighting%2C%20floating%20crystals%20and%20ancient%20ruins%2C%20warm%20earthy%20tones%20with%20golden%20accents%2C%20isekai%20style%2C%20editorial%20quality%20on%20cream%20background&width=600&height=800&seq=cards-manga-03&orientation=portrait"
                alt="51漫画网 - 奇幻异世界"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-2">新番推荐</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">奇幻异世界</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">穿越次元的奇幻冒险，构建恢弘世界观</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Mystery%20manga%20scene%20with%20dramatic%20shadows%20and%20suspenseful%20atmosphere%2C%20film%20noir%20inspired%20composition%2C%20warm%20sepia%20tones%2C%20detective%20theme%2C%20intricate%20line%20art%2C%20editorial%20quality%20on%20cream%20paper&width=600&height=800&seq=cards-manga-04&orientation=portrait"
                alt="51漫画网 - 悬疑推理"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-2">口碑佳作</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">悬疑推理</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">烧脑迷局层层揭开，意想不到的反转剧情</p>
            </div>
          </div>

          <div className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]">
            <div className="aspect-[3/4] w-full overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Comedy%20manga%20illustration%20with%20exaggerated%20funny%20expressions%20and%20playful%20chibi%20characters%2C%20bright%20warm%20colors%2C%20lighthearted%20atmosphere%2C%20gag%20manga%20style%2C%20editorial%20quality%20on%20cream%20background&width=600&height=800&seq=cards-manga-05&orientation=portrait"
                alt="51漫画网 - 搞笑日常"
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-4">
              <span className="inline-block px-2 py-0.5 text-xs font-medium text-accent-700 bg-accent-100/70 rounded-full mb-2">轻松一刻</span>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">搞笑日常</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">笑到停不下来的轻松故事，快乐就是这么简单</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}